import { useEffect, useState } from 'react';
import Select from 'react-select';

const SearchableSelect = ({ onChangeHandler, optionList, value }) => {
    const dataSourceOptions = optionList;
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        const val = { value: value, label: value };
        setSelectedOption(val);
    }, [optionList, value]);

    const handleDtChange = (selectedOption) => {
        console.log("Selected option:", selectedOption);
        if (selectedOption === null || selectedOption.value === 'Please Select') {
            onChangeHandler("");
            return;
        }
        onChangeHandler(selectedOption.value);
    };

    return (
        <Select onChange={handleDtChange}
            classNamePrefix="react-select"
            className="react-select__indicators"
            isClearable={true}
            options={dataSourceOptions} placeholder="Please Select"
            value={selectedOption}
            styles={{
                container: (base) => ({
                    ...base,
                    width: "300px", // control total width
                }),
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isSelected ? 'grey' : 'grey',
                    minHeight: "26px", // height of the select box

                }),
                valueContainer: (base) => ({
                    ...base,
                    height: "30px", // ensure vertical alignment
                    padding: "0 8px",
                }),
                input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                }),
                option: (styles, { data, isDisabled, isFocused, isSelected }) => {

                    return {
                        ...styles,
                        whiteSpace: "nowrap",        // Prevent wrapping
                        overflow: "hidden",          // Hide overflow text
                        textOverflow: "ellipsis",    // Show ellipsis (...)
                        maxWidth: "100%",            // Constrain width
                        backgroundColor: isDisabled
                            ? undefined
                            : isSelected
                                ? "#0066ff"
                                : isFocused
                                    ? "#0066ff1a"
                                    : undefined,
                        color: isSelected ? "#ffffff" : "#000",
                        cursor: isDisabled ? "not-allowed" : "default",

                        ":active": {
                            ...styles[":active"],
                            backgroundColor: !isDisabled
                                ? isSelected
                                    ? data.color
                                    : "#0066ff1a"
                                : undefined,
                        },
                    }
                },
                singleValue: (base) => ({
                    ...base,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                }),
            }}
        />
    );
}
export default SearchableSelect;